import request from '@/router/axios'
import { commonConst } from '@/const/code.js'

export const loginByUsername = (username, password) => {   //登录接口
  const grant_type = 'password';
  const scope = 'server';
  return request({
    url: '/sys/login',
    headers: {
       Authorization: 'Basic d2FnZTp3YWdl',
    },
    method: 'post',
    data: { username: username, password: password},
  });
};





export const requestRefreshToken = (refresh_token) => {
  const grant_type = 'refresh_token';
  const scope = 'server';
  const type = '1';
  const tenantId = commonConst.TENANT_ID;
  return request({
    url: '/auth/oauth/token',
    headers: {
      Authorization: 'Basic d2FnZTp3YWdl',
    },
    method: 'post',
    params: { grant_type, scope, refresh_token,type,tenantId},
  });
};



export const logout = (accesstoken, refreshToken) => request({   //tod  退出接口
  url: '/auth/authentication/removeToken',
  method: 'post',
  params: { accesstoken, refreshToken },
});
export const cacheUser = (userId, orgId, createOrgId) => request({ //todo  缓存用户信息
  url: '/user/user/cache',
  method: 'post',
  data: { userId, orgId, createOrgId },
});

//获取公众号码
export function queryQrCodeUrl() {
  return request({
    url: '/wechat/set/queryQrCodeUrl',
    method: 'GET',
  });
}
